<ckeditor [editor]="Editor" [(ngModel)]="value" [config]="config" #editor></ckeditor>